<template>
	<div v-if="showParentView('page-configuration-process')">
		<section>
			<header-page
				name="configuration"
				:title="$route.meta.title"
			/>
			<div class="px-5 pb-5 mb-5">
				<app-table
					class="mt-5"
					:columns="columns"
					:rows="rows"
					:last-page="lastPage"
					:current-page="currentPage"
					@on-search-event="onSearch"
					@on-page="changePage"
				>
					<template slot="rows" slot-scope="props">
						<td v-show="showRow(columns, 1)" class="is-not-selectable">{{ props.row.code }}</td>
						<td v-show="showRow(columns, 2)">{{ props.row.name }}</td>
						<td v-show="showRow(columns, 3)">{{ props.row.scope }}</td>
						<td v-show="showRow(columns, 4)">{{ props.row.moduleName }}</td>
						<td v-show="showRow(columns, 5)">
							<span :class="props.row.flagSelected === true ? 'color-green bold' : 'color-red bold'">
								{{ props.row.flagSelected ? 'Activo' : 'Inactivo' }}
							</span>
						</td>
						<td v-show="showRow(columns, 6)">
							<app-tooltip-button
							color="blue"
							icon="build"
							text="Asignar Categorías"
							@click-icon="openProcess(props.row)"
							/>
						</td>
					</template>
				</app-table>
			</div>
		</section>
		<v-layout wrap>
			<section class="modal-filter-footer">
				<v-layout xs12 justify-center pt-4 pb-4>
					<v-btn
						class="btn-action caption mr-1"
						color="pink"
						@click.native="returnListTemplate"
					>
						Cancelar
						<img
							class="ml-2"
							:src="`${$imageUrl}/icon-cancel.svg`"
							alt=""
						>
					</v-btn>
					<v-btn
						class="btn-action w-btn caption ml-1 pl-2 pr-2"
						color="blue"
						@click="openAssign"
					>
						Asignar Integración
					</v-btn>
				</v-layout>
			</section>
		</v-layout>
		<router-view></router-view>
	</div>
</template>

<script>
import appTooltipButton from '@/components/shared/app-tooltip-button';

function created() {
	this.loadProcess();
}

async function loadProcess() {
	const params = {
		page: this.params.page,
		perPage: this.params.perPage,
		templateCode: this.$route.params.codeTemplate,
		projectCode: this.$route.params.codeProject,
	};
	const response = await this.$http.get('process', { params });
	this.rows = response.data.data;
	this.lastPage = Number(response.headers['x-last-page']);
}

function openProcess({ id }) {
	this.goTo('page-configuration-process-integration-category', { params: { idProcess: id } });
}

function closeModal() {
	this.openAction = false;
}

function openAssign() {
	this.goTo('page-configuration-process-assign');
}

function changePage(page) {
	this.currentPage = page;
	this.loadProcess();
}

function onSearch(search) {
	this.params.search = search ? search.trim() : null;
	this.loadProcess();
}

function returnListTemplate() {
	this.goTo('page-template');
}

function data() {
	return {
		openAction: false,
		columns: [
			{ id: 1, name: 'Código', value: 'code', checked: true, visible: true },
			{ id: 2, name: 'Nombre', value: 'name', checked: true, visible: true },
			{ id: 3, name: 'Alcance', value: 'scope', checked: true, visible: true },
			{ id: 4, name: 'Modulo', value: 'module', checked: true, visible: true },
			{ id: 5, name: 'Estado', value: 'value', checked: true, visible: true },
			{ id: 6, name: 'Acciones', value: 'name', checked: true, visible: true },
		],
		currentPage: 0,
		lastPage: 0,
		title: 'Configurar Procesos',
		selectedValue: 'flagSelected',
		rows: [],
		params: {
			perPage: 10,
			page: 1,
			search: '',
		},
	};
}

export default {
	name: 'page-configuration-process',
	data,
	created,
	components: {
		appTooltipButton,
	},
	methods: {
		changePage,
		closeModal,
		loadProcess,
		openAssign,
		openProcess,
		onSearch,
		returnListTemplate,
	},
	watch: {
		$route(newVal) {
			if (newVal) {
				if (newVal.name === 'page-configuration-process') {
					this.loadProcess();
				}
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.w-btn {
	width: 125px !important;
}

.color-green {
	color: #4dc68c !important;
}

.bold {
	font-family: map-get($fonts, lato-regular);
	font-weight: bold;
}

.color-red {
	color: map-get($colors, red-icon) !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/process/configuration-process.vue